import React, { useEffect, useState } from "react";
import { Fragment } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { Link } from "react-router-dom";
import { getPassport, getUsernameAndUrl } from "../api";
import { AtomUsersUrl } from "./atom/AtomUsersUrl";
import { AtomLog } from "./atom/Atomlog";
import { useRecoilState } from "recoil";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const navLinkClass =
  "font-poppins text-white/60 hover:text-white px-3 py-2 rounded-md text-sm sm:text-base transition-colors duration-200";

const YouAreIn = () => {
  return (
    <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4">
      <Link to={`/profile`} className={navLinkClass}>
        Customize Profile
      </Link>
      <Link to={`/Marketplace`} className={navLinkClass}>
        Marketplace
      </Link>
      <Link to={`/battlepass`} className={navLinkClass}>
        Battle Pass
      </Link>
    </div>
  );
}

const NotLoggedIn = () => {
  return (
    <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4">
      <Link to={`/battlepass`} className={navLinkClass}>
        Battle Pass
      </Link>
      <a
        href={`/auth/discord`}
        className="font-poppins text-white bg-reored/90 hover:bg-reored px-5 py-2 rounded-full text-sm sm:text-base font-medium transition-all duration-200 shadow-[0_0_25px_rgba(213,60,53,0.35)]"
      >
        Login with Discord
      </a>
    </div>
  );
}

const ProfileData = () => {
  const [log, setlog] = useRecoilState(AtomLog)
  const [image, setimage] = useRecoilState(AtomUsersUrl)
  useEffect(() => {
    getPassport().then((data) => {
      if (data.user.id == 'NOPASS')
        setlog(false)
      else {
        setlog(true)
        getUsernameAndUrl(data.user.id).then(u => {
          setimage(u.displayAvatarURL)
        })
      }
    });
  }, [])
  if (log) {
    return (
      <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
        {/* Profile dropdown */}
        <Menu as="div" className="relative ml-3">
          <div>
            <Menu.Button className="flex rounded-full ring-2 ring-white/20 hover:ring-reored transition-all duration-200 focus:outline-none">
              <span className="sr-only">Open user menu</span>
              <img
                className="h-9 w-9 rounded-full"
                src={image}
                alt=""
              />
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 z-10 mt-3 w-48 origin-top-right rounded-xl bg-voidcard border border-white/10 py-1 shadow-2xl backdrop-blur-xl focus:outline-none">
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to="/profile"
                    className={classNames(active ? 'bg-white/10' : '', 'block px-4 py-2 text-sm text-white/80 font-poppins')}
                  >
                    Your Profile
                  </Link>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <a
                    href="/api/logout"
                    className={classNames(active ? 'bg-white/10' : '', 'block px-4 py-2 text-sm text-white/80 font-poppins')}
                  >
                    Sign out
                  </a>
                )}
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>)
  }
}

const Data = () => {
  const [log, setlog] = useState(false)
  useEffect(() => {
    getPassport().then((data) => {
      if (data.user.id == 'NOPASS')
        setlog(false)
      else {
        setlog(true)
      }
    });
  }, [])
  if (log) {
    return <YouAreIn />
  } else {
    return <NotLoggedIn></NotLoggedIn>
  }
}

const Navbar = () => {
  return (
    <Disclosure as="nav" className="bg-void/70 backdrop-blur-xl border-b border-white/10 sticky top-0 z-50">
      {({ open }) => (
        <>
          <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="relative flex h-16 lg:h-20 items-center justify-between">
              {/* Mobile menu button */}
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-white/60 hover:bg-white/10 hover:text-white focus:outline-none transition-colors duration-200">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>

              {/* Logo and Navigation */}
              <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                <div className="flex flex-shrink-0 items-center">
                  <Link to="/" className="flex items-center gap-3 group">
                    <img
                      src="/reo-logo.jpg"
                      alt="Reo"
                      className="h-9 w-9 sm:h-10 sm:w-10 rounded-full object-cover ring-2 ring-reored/60 shadow-[0_0_20px_rgba(213,60,53,0.4)] group-hover:scale-105 group-hover:ring-reored transition-all duration-200"
                    />
                    <span className="font-Bebas text-2xl text-white tracking-widest">
                      REO <span className="text-white/30 text-base">レオ</span>
                    </span>
                  </Link>
                </div>
                <div className="hidden sm:flex items-center">
                  <div className="ml-6 lg:ml-10 flex space-x-1 lg:space-x-2">
                    <Data />
                  </div>
                </div>
              </div>

              {/* Profile Section */}
              <div className="flex items-center">
                <ProfileData />
              </div>
            </div>
          </div>

          {/* Mobile Navigation Panel */}
          <Disclosure.Panel className="block sm:hidden bg-void/95 backdrop-blur-xl border-t border-white/10">
            <div className="space-y-2 px-4 py-4">
              <Data />
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}

export default Navbar
